
import React from 'react';
import { DialerHeader } from './DialerHeader';
import { DialerMainContent } from './DialerMainContent';

export const DialerLayout = () => {
  console.log('🔍 DialerLayout component rendering');
  
  return (
    <div className="h-screen flex flex-col bg-background overflow-hidden">
      <DialerHeader />
      <DialerMainContent />
    </div>
  );
};
